<template>
  <div class="header">
    <slot></slot>
  </div>
</template>

<script>
export default {
};
</script>

<style scoped>
.header {
  background: #D0DFF5;
  color: #000000;
  text-align: center;
  font-size: 1.3rem;
  font-weight: 700;
  padding: 10px 0;
}
</style>